/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Invalid_HeadersInputs */

const nl_import_api_errors_invalid_headers = /** @type {((inputs: Import_Api_Errors_Invalid_HeadersInputs) => LocalizedString) & { parts: (inputs: Import_Api_Errors_Invalid_HeadersInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Import_Api_Errors_Invalid_HeadersInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Onjuiste kolommen in het bestand. Download de actuele template`)
		}),
		{
			parts: /** @type {(inputs: Import_Api_Errors_Invalid_HeadersInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Onjuiste kolommen in het bestand. " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Download de actuele template" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

/**

* @param {Import_Api_Errors_Invalid_HeadersInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_invalid_headers = /** @type {((inputs?: Import_Api_Errors_Invalid_HeadersInputs, options?: { locale?: "nl" }) => LocalizedString) & { parts: (inputs?: Import_Api_Errors_Invalid_HeadersInputs, options?: { locale?: "nl" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Import_Api_Errors_Invalid_HeadersInputs, { locale?: "nl" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Import_Api_Errors_Invalid_HeadersInputs, options?: { locale?: "nl" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			experimentalStaticLocale ?? options.locale ?? getLocale()
			return nl_import_api_errors_invalid_headers(inputs)
		}),
		{
			parts: /** @type {(inputs?: Import_Api_Errors_Invalid_HeadersInputs, options?: { locale?: "nl" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof nl_import_api_errors_invalid_headers.parts === "function" ? nl_import_api_errors_invalid_headers.parts(inputs) : [{ type: "text", value: nl_import_api_errors_invalid_headers(inputs) }]
			})
		}
	)
);
export { import_api_errors_invalid_headers as "import.api_errors.invalid_headers" }